<template>
  <div class="i-sale-footer">
    <iBaseAnimatedSlider
      sliding-direction="left"
      animation-duration-secs="120"
    >
      <div class="track">
        <template
          v-for="i in REPEAT_CONTENT_TIMES"
          :key="i"
        >
          <span class="divider"></span>
          <span class="divider"></span>
          <span>🔥</span>
          <span> Limited Time • Save 25%</span>
          <span>⚡</span>
          <span v-if="countdown && !countdown.isFinished">
            ENDS IN
            <span class="unit"
              >{{ countdown.daysPadded }}D {{ countdown.hoursPadded }}H {{ countdown.minutesPadded }}M
              {{ countdown.secondsPadded }}S</span
            >
          </span>
          <span v-if="endsAt">
            ENDS
            <span class="unit">{{ DateTime.fromJSDate(endsAt).toFormat("LLL d") }}</span>
          </span>
          <span class="divider"></span>
          <span class="divider"></span>
        </template>
      </div>
    </iBaseAnimatedSlider>
  </div>
</template>
<script setup lang="ts">
import { computed, PropType } from "vue"
import { DateTime } from "luxon"
import { CountdownState } from "@/composables/useCountdown"
import iBaseAnimatedSlider from "@/components/base/BaseAnimatedSlider.vue"

const props = defineProps({
  countdown: { type: Object as PropType<CountdownState | null>, default: null },
  endsAt: { type: Date, default: null }
})

const countdown = computed(() => props.countdown)
const endsAt = computed(() => props.endsAt)
const REPEAT_CONTENT_TIMES = 20
</script>
<style scoped lang="scss">
.i-sale-footer {
  background: $blue-purple-gradient;
  color: #fff;
  text-align: center;
  padding: 8px 16px;
  font-size: 12px;
  height: 52px;
  font-weight: 500;
  z-index: 1000;
  display: flex;
  align-items: center;
  overflow: hidden;

  .track {
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
    width: 100%;

    @media screen and (min-width: $breakpoint-xs) {
      gap: 12px;
    }

    @media screen and (min-width: $breakpoint-sm) {
      gap: 16px;
    }

    @media screen and (min-width: $breakpoint-md) {
      gap: 20px;
    }

    span {
      text-wrap: nowrap;
    }

    .unit {
      text-transform: uppercase;
    }
  }

  @media screen and (min-width: $breakpoint-xs) {
    font-size: 12px;
  }

  @media screen and (min-width: $breakpoint-sm) {
    font-size: 14px;
  }

  @media screen and (min-width: $breakpoint-md) {
    font-size: 16px;
  }
}
</style>
